var map = {
	"./1分竞猜_n.svg": "08eb",
	"./1分竞猜_s.svg": "08eb3",
	"./add-circle.svg": "876a",
	"./add.svg": "c2a3",
	"./backtop.svg": "79b3",
	"./bottom_下载_n.svg": "76c1",
	"./bottom_下载_s.svg": "9ab6",
	"./bottom_下载_sblack-gold-theme.svg": "4ebe",
	"./bottom_客服_n.svg": "297c",
	"./bottom_客服_s.svg": "9721",
	"./bottom_客服_sblack-gold-theme.svg": "18f7",
	"./bottom_我的_n.svg": "1d3e",
	"./bottom_我的_s.svg": "43b8",
	"./bottom_我的_sblack-gold-theme.svg": "c621",
	"./bottom_推荐_n.svg": "ce37",
	"./bottom_推荐_s.svg": "4239",
	"./bottom_推荐_sblack-gold-theme.svg": "d345",
	"./bottom_活动_n.svg": "38d8",
	"./bottom_活动_s.svg": "26ee",
	"./bottom_活动_sblack-gold-theme.svg": "c013",
	"./bottom_首页_n.svg": "d9c3",
	"./bottom_首页_s.svg": "3c02",
	"./bottom_首页_sblack-gold-theme.svg": "8825",
	"./caipiao.svg": "18bc",
	"./close.svg": "7710",
	"./copy.svg": "19b6",
	"./down_button.svg": "90ac",
	"./good.svg": "9765",
	"./icon_VIP特权.svg": "537a",
	"./icon_top.svg": "e354",
	"./icon_交易记录.svg": "35f1",
	"./icon_代理.svg": "6b0b",
	"./icon_代理合作.svg": "6b0b7",
	"./icon_任务.svg": "d85d",
	"./icon_充提记录.svg": "3d08",
	"./icon_刷新.svg": "b1c8",
	"./icon_口令红包.svg": "fee7",
	"./icon_团队输赢报表.svg": "a661",
	"./icon_地址.svg": "2cf1",
	"./icon_复制.svg": "12e2",
	"./icon_复制black-gold-theme.svg": "74fd",
	"./icon_多语言.svg": "71fc",
	"./icon_密码.svg": "a1dd",
	"./icon_我的任务.svg": "a843",
	"./icon_我的收入.svg": "a8434",
	"./icon_我的红包.svg": "a84348",
	"./icon_扫码.svg": "9f12",
	"./icon_投注记录.svg": "5552",
	"./icon_推荐VPN.svg": "0502",
	"./icon_提现.svg": "4ba2",
	"./icon_注意事项.svg": "84c9",
	"./icon_深色模式.svg": "91df",
	"./icon_筹码类型.svg": "a4dd",
	"./icon_红包.svg": "d963",
	"./icon_语言.svg": "3fbf",
	"./icon_购买货币.svg": "36a2",
	"./icon_输赢报表.svg": "71e2",
	"./icon_邀请好友.svg": "f323",
	"./icon_邮箱.svg": "d21b",
	"./menu_by.svg": "9014",
	"./menu_caipiao.svg": "b7d2",
	"./menu_dz.svg": "db0a",
	"./menu_qp.svg": "4141",
	"./menu_rm.svg": "9e4a",
	"./menu_rrys.svg": "42dc",
	"./menu_ty.svg": "2c93",
	"./menu_zr.svg": "dd56",
	"./minus-circle.svg": "a2c7",
	"./minus.svg": "dc8f",
	"./qq.svg": "1430",
	"./save.svg": "0e55",
	"./search.svg": "8e8d",
	"./share.svg": "5306",
	"./star.svg": "708a",
	"./tab2_rrys.svg": "0350",
	"./tab_rrys.svg": "323e",
	"./tab_捕鱼.svg": "0ca6",
	"./tab_热门_n.svg": "d1c1",
	"./tab_热门_s.svg": "366c",
	"./tab_热门_sblack-gold-theme.svg": "11e3",
	"./tab_首页_n.svg": "8ef4",
	"./tab_首页_s.svg": "0e16",
	"./tab_首页_sblack-gold-theme.svg": "932b",
	"./task不可领取.svg": "5826",
	"./task切换.svg": "b5ce",
	"./task切换灰.svg": "b5ce2",
	"./task可领取.svg": "abc2",
	"./task完成.svg": "d815",
	"./task数字按钮.svg": "8c57",
	"./task箭头.svg": "f32f",
	"./task规则.svg": "5e62",
	"./user.svg": "b3b5",
	"./wechat.svg": "80da",
	"./中国.svg": "ab6ff",
	"./中币.svg": "254f",
	"./代理_n.svg": "dc0c",
	"./代理_s.svg": "cba4",
	"./代理合作.svg": "e226",
	"./体育_n.svg": "480c",
	"./体育_s.svg": "d2d5",
	"./俄罗斯.svg": "092a",
	"./充.svg": "7b94",
	"./充值.svg": "3dda",
	"./公告.svg": "6245",
	"./公告black-gold-theme.svg": "0476",
	"./关闭.svg": "d854",
	"./切右换.svg": "e4cd",
	"./删除.svg": "2366",
	"./单选框_n.svg": "a9d4",
	"./单选框_s.svg": "a9d4c",
	"./印度.svg": "4706",
	"./即开竞猜_n.svg": "2b3f",
	"./即开竞猜_s.svg": "2b3f5",
	"./口令红包.svg": "530f",
	"./右箭头.svg": "2079",
	"./图标_任务.svg": "ec2c",
	"./图标_我的收入.svg": "6d8f",
	"./图标_提现.svg": "ec2cd",
	"./图标_更多记录.svg": "9f62",
	"./图标_红包.svg": "ec2cd9",
	"./图标_邀请好友.svg": "a4ff",
	"./土耳其.svg": "9dc2",
	"./复选框_n.svg": "638e",
	"./复选框_s.svg": "638e1",
	"./复选框_sblack-gold-theme.svg": "1bec",
	"./多语言.svg": "6c73",
	"./安全中心.svg": "92c5",
	"./安全中心1.svg": "280f",
	"./完成.svg": "3b4f",
	"./客服.svg": "352a",
	"./左切换.svg": "0e21",
	"./左箭头.svg": "adf9",
	"./巴西.svg": "cef4",
	"./币安.svg": "236e",
	"./常见问题-下拉.svg": "4a4a",
	"./我的_n1.svg": "d793",
	"./我的_s1.svg": "6ac5",
	"./我的收入.svg": "af49",
	"./投注记录.svg": "6f55",
	"./抽屉_close.svg": "20a3",
	"./推荐.svg": "042a",
	"./推荐VPN.svg": "f506",
	"./提现.svg": "f3e3",
	"./搜索.svg": "bb68",
	"./日本.svg": "1270",
	"./棋牌_n.svg": "49aa",
	"./棋牌_s.svg": "fdf3",
	"./欧易.svg": "8ca2",
	"./法国.svg": "7baf",
	"./泰国.svg": "6660",
	"./活动_n1.svg": "6d10",
	"./活动_s1.svg": "0aeb",
	"./火币网.svg": "c446",
	"./瑞典.svg": "0823",
	"./电子_n.svg": "2df2",
	"./电子_s.svg": "6c0b",
	"./白_1分竞猜备份.svg": "82d8",
	"./白_体育备份.svg": "5c1c",
	"./白_即开竞猜备份.svg": "d7e3",
	"./白_棋牌备份.svg": "1b1d",
	"./白_热门备份.svg": "1fd1",
	"./白_电子备份.svg": "df73",
	"./白_真人备份.svg": "06d2",
	"./真人_n.svg": "b915",
	"./真人_s.svg": "7b96",
	"./筹码切换.svg": "e0eb",
	"./箭头.svg": "f338",
	"./红包.svg": "1993",
	"./英国.svg": "842a",
	"./菜单_n.svg": "2307",
	"./菜单_s.svg": "0b9e",
	"./规则说明.svg": "0609",
	"./语言.svg": "c533",
	"./语言1.svg": "6441",
	"./语言弹窗关闭.svg": "9130",
	"./越南.svg": "8ca3",
	"./返回.svg": "b56b",
	"./返回1.svg": "6620",
	"./进入详情_箭头.svg": "f7b5",
	"./邀请好友.svg": "c4f4",
	"./钱包.svg": "ec4c",
	"./钱包背景.svg": "ec4c2",
	"./韩国.svg": "9e3c",
	"./首页.svg": "1cae",
	"./首页_n1.svg": "cf35",
	"./首页_ntab.svg": "2da4",
	"./首页_s1.svg": "432a",
	"./首页_stab.svg": "216c",
	"./首页_捕鱼.svg": "7c97"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";